import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

import media from 'themes/media';

const Trigger = styled.div`
  color: white;
  cursor: pointer;
  user-select: none;
  font-size: 8px;
  line-height: 12px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  display: flex;

  ${media.greaterThan('desktop')`
    flex-direction: column;
    align-items: center;
    font-size: 10px;
  line-height: 14px;
  `}
`;

const Arrow = styled.div`
  margin-left: 5px;
  transform-origin: center;
  transform: ${ifProp(
    'isOpen',
    css`
  rotate(180deg);
  `,
    css`
  rotate(0deg);
  `
  )};
`;

const SelectedValue = styled.div`
  font-size: 8px;
  line-height: 12px;
  text-transform: uppercase;
  color: white;
  margin-left: 8px;
  display: flex;
  align-items: center;
  ${ifProp(
    'isOpen',
    css`
      color: #00d1df;
    `
  )};

  ${media.greaterThan('desktop')`
     font-size: 10px;
    line-height: 14px;
  `}
`;

const FloatingArrow = styled.img`
  width: 22px;
  left: ${prop('left', 0)}px;
  ${ifProp(
    { placement: 'top' },
    css`
      bottom: -6px;
    `
  )};
  ${ifProp(
    { placement: 'bottom' },
    css`
      top: -6px;
      transform: rotate(180deg);
    `
  )};
  position: absolute;
  transform-origin: center;
`;

const Options = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #003765;
  width: 80px;
  border-radius: 10px;
  padding: 10px;
  ${ifProp(
    'shadow',
    css`
      box-shadow: rgb(0 0 0 / 35%) 3px 6px 6px;
    `
  )}
`;

const Option = styled.div`
  text-align: center;
  padding: 3px 10px;
  font-size: 10px;
  color: white;
  cursor: pointer;
  border-radius: 30px;
  text-transform: uppercase;
  line-height: 14px;

  &:hover {
    background: #215988;
  }

  ${ifProp(
    'isActive',
    css`
      background-color: #215988;
      color: white;

      :hover {
        cursor: default;
        background-color: #215988;
        color: white;
      }
    `
  )}
`;

export { Options, Option, Trigger, Arrow, FloatingArrow, SelectedValue };
